export const viewOnlyRoleTitle = 'View-Only';
export const viewOnlyListingEditorRoleTitle = 'View-Only + Listings';
